import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeBanner } from 'slice/bannerSlice';
import AdminTable from 'common/AdminTable';
import { getRequest } from 'apis/ApiInstence';

const QuestionList = () => {
    const [cartData, setCartData] = React.useState([]);
    const dispatch = useDispatch()
    const loadInitialData = async () => {
        const res = await getRequest(`questions`, true);
        if (res?.status) {
            setCartData(res)
        } else {
            toast('Failed to update QR!')
        }
    };
    useEffect(() => {
        loadInitialData()
    }, [])

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${process.env.REACT_APP_BACKEND}asserts/question_images/${row.original.question}`}
                    alt={row.original.name}
                    width={100}
                />
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <button
                    className="btn removebtn"
                    onClick={() => dispatch(removeBanner(row.original.id))}
                >
                    Remove
                </button>
            ),
        },
    ];

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4">
                    <h4 className="font-weight-bold">Slider List</h4>
                </div>
                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : (
                    <p>No slider available</p>
                )}
            </div >
        </>
    )
}

export default QuestionList;
